module.exports = __webpack_public_path__ + "static/img/2.a36c38e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/1.16/2.jpg
// module id = /E7H
// module chunks = 1